<svg viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 24V21H22V24H14ZM6 13.5V10.5H30V13.5H6ZM0 3V0H36V3H0Z" fill="currentColor"/>
</svg>
